import React from 'react';
import { RegisterTerminalModalJustifiSteps, RegisterTerminalModalStripeSteps } from '../hooks';
import { StepperProps } from '../types';
import { JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES } from '../utils';
import { ConnectToWifiStep1, ConnectToWifiStep2, ConnectToWifiStep3, IncorrectPassword } from './connect-to-wifi';
import { GenrateDeviceId } from './pair-terminal';
import { PlugInTerminal, PreCheck } from './power-up-terminals';

type JustifiAllStepsProps = {
  goToBigBang?: () => void;
  goToStep?: (step: RegisterTerminalModalJustifiSteps | RegisterTerminalModalStripeSteps) => void;
  goBack?: () => void;
  onComplete: () => void;
  onRegisterTerminal: () => void;
  Stepper: React.FC<StepperProps>;
  locationId?: string;
};

export const JustifiAllSteps = ({
  goToBigBang,
  goToStep,
  goBack,
  Stepper,
  locationId,
  onComplete,
  onRegisterTerminal,
}: JustifiAllStepsProps) => {
  return (
    <>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.PreCheck].heading}
        id={RegisterTerminalModalJustifiSteps.PreCheck}
      >
        <PreCheck goBack={goToBigBang} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.TurnOnTerminal].heading}
        id={RegisterTerminalModalJustifiSteps.TurnOnTerminal}
        parentId={RegisterTerminalModalJustifiSteps.PreCheck}
      >
        <PlugInTerminal goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.ConnectToWifiStep1].heading}
        id={RegisterTerminalModalJustifiSteps.ConnectToWifiStep1}
        parentId={RegisterTerminalModalJustifiSteps.TurnOnTerminal}
      >
        <ConnectToWifiStep1 goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.ConnectToWifiStep2].heading}
        id={RegisterTerminalModalJustifiSteps.ConnectToWifiStep2}
        parentId={RegisterTerminalModalJustifiSteps.ConnectToWifiStep1}
      >
        <ConnectToWifiStep2 goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.ConnectToWifiStep3].heading}
        id={RegisterTerminalModalJustifiSteps.ConnectToWifiStep3}
        parentId={RegisterTerminalModalJustifiSteps.ConnectToWifiStep2}
      >
        <ConnectToWifiStep3 goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.IncorrectPassword].heading}
        id={RegisterTerminalModalJustifiSteps.IncorrectPassword}
        parentId={RegisterTerminalModalJustifiSteps.ConnectToWifiStep3}
      >
        <IncorrectPassword goBack={goBack} goToStep={goToStep} />
      </Stepper>
      <Stepper
        components={{ Footer: () => null }}
        label={JUSTIFI_REGISTER_TERMINAL_STEPS_TITLES[RegisterTerminalModalJustifiSteps.GenrateDeviceId].heading}
        id={RegisterTerminalModalJustifiSteps.GenrateDeviceId}
        parentId={RegisterTerminalModalJustifiSteps.ConnectToWifiStep3}
      >
        <GenrateDeviceId
          goBack={goBack}
          goToStep={goToStep}
          locationId={locationId}
          onSuccess={onComplete}
          onTerminalPaired={onRegisterTerminal}
        />
      </Stepper>
    </>
  );
};

JustifiAllSteps.displayName = 'RegisterTerminalJustifiStep';
